import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators'
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { environment } from '../../../../../../environments/environment';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
@Injectable({
  providedIn: 'root'
})
export class LangServices {

  constructor(
    private httpClient: HttpClient,
    private headerBasicAuthorization: HeaderBasicAuthorizationService

  ) { }

    getLangs(origen="WEB"){
        return this.httpClient.get(`${environment.api.WS_IT.url}/Lang/GetLangs?origin=${origen}`, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }).pipe(map(response => response));
    }

    getLangsByType(lang="es",type="LOGIN"){
        return this.httpClient.get(`${environment.api.WS_IT.url}/Lang/GetLangsByType?lang=${lang}&type=${type}`, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }).pipe(map(response => response));
    }
    getFormBaseLANG(type){
        return this.httpClient.get(`${environment.api.WS_IT.url}/Lang/GetFormBaseLANG?type=${type}`, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }).pipe(map(response => response));
    }
    getListLanguages(){
        return this.httpClient.get(`${environment.api.WS_IT.url}/Lang/ListLanguages`, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }).pipe(map(response => response));
    }

    SaveJSONLang(model:{id:number,_json:string}){
        return this.httpClient.post(`${environment.api.WS_IT.url}/Lang/SaveJSONLang`,model, {
            headers: this.headerBasicAuthorization.get(ApiEnum.WS_IT)
        }).pipe(map(response => response));
    }
}
